import * as tslib_1 from "tslib";
// @flow
/* eslint no-param-reassign:0 */
import * as React from 'react';
import ReactDOM from 'react-dom';
import contains from 'dom-helpers/query/contains';
import debounce from 'lodash.debounce';
import EventListener from 'react-event-listener';
import { Iframe } from '../Dialog';
import { getScrollTop } from '../utils/domHelpers';
import Modal from '../Modal';
import Grow from '../transitions/Grow';
import PopoverPosition from './PopoverPosition';
import StylePaper from './StylePaper';
import zIndex from '../styles/zIndex';
import PopoverContent from './PopoverContent';
/**
 * 获取CSS3变换原点值。
 *
 * @param {TransitionOrigin} transformOrigin
 */
function getTransformOriginValue(transformOrigin) {
    return [transformOrigin.horizontal, transformOrigin.vertical]
        .map(function (n) { return (typeof n === 'number' ? n + "px" : n); })
        .join(' ');
}
/**
 * @ReactComponent
 *
 * Popover
 *
 * @class Popover
 * @extends {React.Component<PopoverProps>}
 */
var Popover = /** @class */ (function (_super) {
    tslib_1.__extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contentRef = React.createRef();
        _this.iframeRef = React.createRef();
        /**
         * 定位元素
         */
        _this.setPositioningStyles = function (element) {
            if (element && element.style) {
                var positioning = _this.getPositioningStyle(element);
                element.style.top = positioning.top;
                element.style.left = positioning.left;
                element.style.transformOrigin = positioning.transformOrigin;
            }
        };
        /**
         * 获取元素的位置信息
         */
        _this.getPositioningStyle = function (element) {
            var _a = _this.props, marginThreshold = _a.marginThreshold, anchorOrigin = _a.anchorOrigin, transformOrigin = _a.transformOrigin, anchorEl = _a.anchorEl;
            var windowRect = {
                width: window.innerWidth,
                height: window.innerHeight,
            };
            var anchorRect = (anchorEl || document.body).getBoundingClientRect();
            var targetRect = element.getBoundingClientRect();
            var _b = new PopoverPosition(anchorOrigin, transformOrigin, marginThreshold).getPosition(windowRect, anchorRect, targetRect, _this.getContentAnchorOffset(element)), top = _b.top, left = _b.left, newTransitionOrigin = _b.transformOrigin;
            return {
                top: Math.round(top) + "px",
                left: Math.round(left) + "px",
                transformOrigin: getTransformOriginValue(newTransitionOrigin),
            };
        };
        _this.transitionEl = undefined;
        _this.handleEnter = function (element, isAppearing) {
            if (_this.props.onEnter) {
                _this.props.onEnter(element, isAppearing);
            }
            _this.setPositioningStyles(element);
        };
        _this.handleResize = debounce(function () {
            var element = ReactDOM.findDOMNode(_this.transitionEl);
            _this.setPositioningStyles(element);
        }, 166);
        _this.onMouseUp = function (event) {
            event.stopPropagation();
        };
        _this.onPaperRef = function (paperDom) {
            if (paperDom && _this.paperDom !== paperDom) {
                if (_this.paperDom) {
                    _this.paperDom.removeEventListener('mouseup', _this.onMouseUp, true);
                }
                _this.paperDom = paperDom;
                _this.paperDom.addEventListener('mouseup', _this.onMouseUp, true);
            }
            if (!paperDom && _this.paperDom) {
                _this.paperDom.removeEventListener('mouseup', _this.onMouseUp, true);
            }
        };
        _this.onEntered = function (node, isAppearing) {
            _this.syncPaperStyle();
            if (_this.props.onEntered) {
                _this.props.onEntered(node, isAppearing);
            }
        };
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        if (this.props.action) {
            this.props.action({
                updatePosition: this.handleResize,
            });
        }
    };
    Popover.prototype.componentWillUnmount = function () {
        this.handleResize.cancel();
    };
    Popover.prototype.getContentAnchorOffset = function (element) {
        var _a = this.props, getContentAnchorEl = _a.getContentAnchorEl, anchorReference = _a.anchorReference;
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === 'anchorEl') {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && contains(element, contentAnchorEl)) {
                var scrollTop = getScrollTop(element, contentAnchorEl);
                contentAnchorOffset =
                    contentAnchorEl.offsetTop +
                        contentAnchorEl.clientHeight / 2 -
                        scrollTop || 0;
            }
        }
        return contentAnchorOffset;
    };
    Popover.prototype.componentDidUpdate = function () {
        this.syncPaperStyle();
    };
    Popover.prototype.syncPaperStyle = function () {
        var content$ = this.contentRef.current;
        if (content$ && this.paperDom) {
            var height = content$.getBoundingClientRect().height;
            var paperHeight = this.paperDom.getBoundingClientRect().height;
            if (height > paperHeight) {
                this.paperDom.style.bottom = '0px';
            }
        }
    };
    Popover.prototype.render = function () {
        var _this = this;
        var _a = this.props, anchorEl = _a.anchorEl, anchorOrigin = _a.anchorOrigin, anchorPosition = _a.anchorPosition, anchorReference = _a.anchorReference, children = _a.children, elevation = _a.elevation, getContentAnchorEl = _a.getContentAnchorEl, marginThreshold = _a.marginThreshold, onEnter = _a.onEnter, onEntered = _a.onEntered, onEntering = _a.onEntering, onExit = _a.onExit, onExited = _a.onExited, onExiting = _a.onExiting, open = _a.open, PaperProps = _a.PaperProps, role = _a.role, transformOrigin = _a.transformOrigin, TransitionProp = _a.transition, transitionDuration = _a.transitionDuration, action = _a.action, other = tslib_1.__rest(_a, ["anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "transition", "transitionDuration", "action"]);
        var transitionProps = {
            timeout: null,
        };
        // The provided transition might not support the auto timeout value.
        if (TransitionProp === Grow) {
            transitionProps.timeout = transitionDuration;
        }
        return (React.createElement(Modal, tslib_1.__assign({ open: open, BackdropProps: { visible: false } }, other, { zIndex: zIndex.popover }),
            React.createElement(TransitionProp, tslib_1.__assign({ appear: true, in: open, onEnter: this.handleEnter, onEntered: this.onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, role: role, ref: function (node) {
                    _this.transitionEl = node;
                } }, transitionProps),
                React.createElement(StylePaper, { innerRef: this.onPaperRef },
                    React.createElement(EventListener, { target: "window", onResize: this.handleResize }),
                    React.createElement(PopoverContent, tslib_1.__assign({ fullWidth: true, elevation: elevation }, PaperProps, { innerRef: this.contentRef }), children),
                    React.createElement(Iframe, { frameBorder: 0, scrolling: false, absolute: true })))));
    };
    Popover.defaultProps = {
        anchorReference: 'anchorEl',
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
        elevation: 8,
        marginThreshold: 16,
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
        transition: Grow,
        transitionDuration: 'auto',
    };
    return Popover;
}(React.Component));
export default Popover;
//# sourceMappingURL=Popover.js.map